const siteMetadata = {
    title: `Guitarist mao official website`,
    siteUrl: `https://maonyoro.com`,
    capitalizeTitleOnHome: false,
    logo: `/images/logo.png`,
    icon: `/images/icon.png`,
    titleImage: `/images/nyorochan_bg.png`,
    ogImage: `https://maonyoro.com/images/nyorochan_black.png`,
    twoColumnWall: true,
    cookiePolicy: false,
    introTag: `- にょろの巣 -`,
    description: `Guitarist maonyoro's website.`,
    // about: "トップページ内の2項目目「About」の文字列",

    // twitter card の「コンテンツ作成者のTwitterID」
    author: `@maonyoro`,
    blogItemsPerPage: 10,
    portfolioItemsPerPage: 10,
    musicItemsPerPage: 10,
    darkmode: true,
    switchTheme: false,
    navLinks: [
        {
            name: "home",
            url: "/",
        },
        {
            name: "maonyoro",
            url: "/about",
        },
        {
            name: "music",
            url: "/music",
        },
        {
            name: "news",
            url: "/blog",
        },
    ],
    footerLinks: [
        {
            name: "お問い合わせ",
            url: "/contact",
        },
        {
            name: "CRUEL REASON",
            url: "http://cruel-reason.net",
        },
    ],
    social: [
        {
            name: "Twitter",
            icon: "/images/Twitter.svg",
            url: "https://twitter.com/maonyoro",
        },
        {
            name: "Instagram",
            icon: "/images/Instagram.svg",
            url: "https://www.instagram.com/maonyoro",
        },
        {
            name: "Youtube",
            icon: "/images/Youtube.svg",
            url: "https://www.youtube.com/channel/UCLU-wRjQzlt04VlbI3IDh8g",
        },
        {
            name: "Note",
            icon: "/images/Note.png",
            url: "https://note.com/maonyoro",
        },
        {
            name: "Clubhouse",
            icon: "/images/Clubhouse.png",
            url: "https://www.joinclubhouse.com/@maonyoro",
        },
    ],
    contact: {
        // leave empty ('') or false to hide form
        api_url: "",
        description: ``,
        mail: "",
        phone: "",
        address: "",
    },
    disqus: "elemental-netlify-com",
}

// 問合せフォームを使う場合のバリデーション
const beforeContactFormSubmit = data => {
    // Code 0 - success
    // Code 1 - Name
    // Code 2 - Email
    // Code 3 - Message
    // Code 4 - Other
    const errors = []

    if (data.name.trim().length < 2) {
        errors.push({
            code: 1,
            message: "Enter a name",
        })
    }

    if (!data.email.match(/[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/)) {
        errors.push({
            code: 2,
            message: "Enter a valid email address",
        })
    }

    if (data.message.trim().length < 15) {
        errors.push({
            code: 3,
            message: "Enter a message with atleast 15 characters",
        })
    }

    if (errors.length > 0)
        return {
            result: false,
            errors: errors,
        }

    return {
        data: {
            name: data.name,
            email: data.email,
            message: data.message,
        },
        result: true,
    }
}

const contactFormSubmit = async (api, data) => {
    let res: any = await fetch(api, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })

    res = await res.json()

    if (res.success) {
        return {
            result: true,
        }
    }
    return {
        result: false,
        ...res,
    }
}

// デフォルト値なので特にいじる必要ない
const defaults = {
    disqus: null,
    twoColumnWall: true,
    darkmode: false,
    switchTheme: true,
    capitalizeTitleOnHome: true,
    cookiePolicy: false
}

Object.keys(defaults).forEach(item => {
    if (siteMetadata[item] === undefined) {
        siteMetadata[item] = defaults[item]
    }
})

export { siteMetadata, beforeContactFormSubmit, contactFormSubmit }
